export default {
  name: 'spotted-on-etsy',
  path: '/spotted-on-etsy',
  component: () => import('@/modules/spotted-on-etsy/pages/Index.vue'),
  meta: {
    metaTags: [
      {
        content: 'Spotted on Etsy.',
        name: 'description',
      },
      {
        page_slug: 'spotted-on-etsy',
      },
    ],
    requiresAuth: true,
    title: 'eRank — Spotted on Etsy',
  },
};
